<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Клиенты <router-link class="btn btn-primary" :to="{ name: 'client-add' }">+ Добавить клиента</router-link></h2>

    <resource-list
      url="/clients"
      current-sort="contract_number"
      init-sort-type="asc"
      resource-name="clients"
      :show-per-page="false"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
      @first-id="updateClientId"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'clients',
  components: { resourceList },
  // mounted () {
  //   if (this.$route.params.apartment_id) {
  //     this.apartmentId = this.$route.
  //   }
  // }
  data () {
    return {
      total: null,
      clientId: null,

      apartmentId: null,
      fields: [
        { name: 'full_name', label: 'Адрес', sort: false },
        { name: 'contract_number', label: '№ договора', sort: true },
        { name: 'balance', label: 'Баланс', sort: true, money: true }
      ],
      filters: {
        apartment: this.$route.params.apartment_id
      },
      actionRoutes: [
        { name: 'apartment-client-details', idName: 'client_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    },
    updateClientId (val) {
      this.clientId = val

      if (this.clientId) {
        this.$router.push({ name: 'apartment-client-details', params: { client_id: this.clientId } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Clients.vue?09691cf9